module.exports = __webpack_public_path__ + "img/GuoYanJieDu2.9f3f1668.png";